import React from "react";
import { motion } from "framer-motion";
import { useApp } from "../context/AppContext";
import LanguageToggle from "./LanguageToggle";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_timeshare-calculator/artifacts/7gkgelre_LOGOTIPO%20ALTERNATIVO%20blanco.png";
const HERO_URL =
  "https://customer-assets.emergentagent.com/job_timeshare-calculator/artifacts/4jqegadj_Sunset%20Plaza%2025_%20-%20SWP22%20%281%29.jpg";

const Hero = ({ onStart }) => {
  const { t } = useApp();
  return (
    <section className="relative min-h-[100vh] w-full overflow-hidden" data-testid="hero-section">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_URL}')` }}
        aria-hidden
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-[#0a0a0c]" aria-hidden />

      {/* Top bar */}
      <div className="relative z-10 mx-auto flex max-w-7xl items-center justify-between px-6 py-6 sm:px-8 lg:px-12">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Ourigen"
            className="h-12 w-12 object-contain sm:h-14 sm:w-14"
            data-testid="brand-logo"
          />
          <span className="font-display text-xl tracking-[0.4em] text-white sm:text-2xl">
            OURIGEN
          </span>
        </div>
        <LanguageToggle className="text-white" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-96px)] max-w-5xl flex-col items-center justify-center px-6 pb-24 pt-12 text-center sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-6 text-xs tracking-luxury text-[#D4AF37] sm:text-sm"
          data-testid="hero-eyebrow"
        >
          {t("hero_eyebrow")}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.15 }}
          className="font-display text-4xl font-medium leading-[1.1] text-white sm:text-5xl lg:text-6xl"
          data-testid="hero-title"
        >
          {t("hero_title")}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35 }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg"
          data-testid="hero-subtitle"
        >
          {t("hero_subtitle")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.55 }}
          className="mt-12 flex flex-col items-center gap-6"
        >
          <button
            type="button"
            onClick={onStart}
            className="bg-[#D4AF37] px-12 py-5 text-xs font-bold uppercase tracking-luxury text-black transition-all duration-300 hover:bg-white hover:shadow-[0_20px_60px_rgba(212,175,55,0.45)]"
            data-testid="hero-cta-start"
          >
            {t("cta_start")}
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
